/**
 * Handles the upload on a file as soon as the file gets picked,
 * dispatching events as the upload progresses
 * @module lib/file_upload_on_change
 */

// CSS Selector for the input itself
const SELECTOR = '.js-file-upload-on-change';
// CSS Selector for the hidden field that will get the ID returned by the server
export const SELECTOR_HIDDEN_FIELD = '.js-file-upload-on-change__attachment_id';

// The URL to which upload the file
const ATTR_UPLOAD_URL = 'data-file-upload-url';

export const EVENT_START = 'file-upload:start';
export const EVENT_SUCCESS = 'file-upload:success';
export const EVENT_PROGRESS = 'file-upload:progress';
export const EVENT_UPLOADED = 'file-upload:uploaded';
export const EVENT_ERROR = 'file-upload:error';
export const EVENT_COMPLETE = 'file-upload:complete';

export default function setupFileUploadOnChange() {
  $(document).on('change', SELECTOR, async ({ target }) => {
    const $attachmentField = findAttachmentField(target);

    // We only want to upload if there are files set already
    if (target.files.length) {
      const file = target.files[0];
      const uploadUrl = target.getAttribute(ATTR_UPLOAD_URL);

      try {
        $(target).trigger(EVENT_START);
        // Get presigned URL
        const [basePath, queryString] = uploadUrl.split('?');
        const presignUrl = `${basePath}/presign${queryString ? '?' + queryString : ''}`;

        const presignResponse = await $.ajax({
          url: presignUrl,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          data: JSON.stringify({
            attachment_file_name: file.name,
            attachment_content_type: file.type,
          }),
          contentType: 'application/json',
          dataType: 'json',
        });

        const { url: presignedUrl, path, video_uuid } = presignResponse;

        // Upload to S3 using jQuery AJAX for progress tracking
        if (presignResponse) {
          await $.ajax({
            url: presignedUrl,
            type: 'PUT',
            data: file,
            contentType: file.type,
            processData: false,
            xhr: function () {
              const xhr = new window.XMLHttpRequest();
              xhr.upload.addEventListener('progress', ({ lengthComputable, loaded, total }) => {
                if (lengthComputable) {
                  const progressPercent = (100 * loaded) / total;
                  $(target).trigger(EVENT_PROGRESS, progressPercent, xhr);
                  if (progressPercent === 100) {
                    $(target).trigger(EVENT_SUCCESS, xhr);
                  }
                }
              });
              return xhr;
            },
          });

          // Notify backend of successful upload
          const createResponse = await $.ajax({
            url: uploadUrl,
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            data: JSON.stringify({
              uuid_slug: video_uuid,
              s3_source_key: path.replace(/^\//, ''),
              attachment_file_name: file.name,
              attachment_content_type: file.type,
              attachment_file_size: file.size,
            }),
            contentType: 'application/json',
            dataType: 'json',
          });

          if (createResponse) {
            // Backup only the original one in case of multiple replacements
            if (!$attachmentField.attr('data-value')) {
              $attachmentField.attr('data-value', $attachmentField.attr('value'));
            }
            $attachmentField.prop('value', createResponse.video_uuid);

            $(target).trigger(EVENT_SUCCESS);
          } else {
            throw new Error('Failed to process upload');
          }
        } else {
          throw new Error('Video validation failed');
        }
      } catch (error) {
        // Video record did not finish creating
        $(target).trigger(EVENT_ERROR, error);
      } finally {
        $(target).trigger(EVENT_COMPLETE);
      }
    } else {
      // File is not uploaded
      $attachmentField.attr('value', $attachmentField.attr('data-value') || '');
    }
  });

  // Disables the field before submit so it doesn't get sent
  // alongside the form
  $(document).on('submit ajax:before', ({ target }) => {
    $(SELECTOR, target).prop('disabled', true);
  });

  // Re-enable the field after the upload ajax finishes
  // in case of errors
  $(document).on('ajax:complete', ({ target }) => {
    $(SELECTOR, target).prop('disabled', false);
  });
}

function findAttachmentField(fileInput) {
  return $(fileInput).closest('fieldset').find(SELECTOR_HIDDEN_FIELD);
}
